import axios from "axios";

const getFlatfileUploadBatchDetails = async (batchId: string) => {
  const response = await axios.get(
    `https://api.us.flatfile.io/rest/batch/${batchId}`,
    {
      headers: {
        "X-Api-Key": `${process.env.REACT_APP_FLATFILE_ACCESS_KEY_ID}+${process.env.REACT_APP_FLATFILE_SECRET}`
      }
    }
  );
  return response.data;
};

export const flatfileService = {
  batch: {
    get: getFlatfileUploadBatchDetails
  }
};
